export class CompleteActivityWithoutDevicesModel {
    requestId: number;
    finishDateFact: Date;
    comment: String;
    activityId: number;
    activityResultIds: number[] = [];
    activityWorkflowTransitionId: number;
    merchantMemberName: string;
    merchantMemberEmail: string;
    newActivityStatusId: number;
}